export default "__VITE_ASSET__BIN13st3__"